import {TextField, TextFieldProps} from "@mui/material"
import React from "react"
import {humanizeCarType} from "~/apps/packages/passes/utils";



export type CarTypeSelectProps = Omit<TextFieldProps, "onChange"> & {
    onChange?: (value?: number) => void
}


export const CarTypeSelect = (props: CarTypeSelectProps) => {
    const {onChange, ...other} = props;
    const options = [
        {label: "Не выбран", value: null},
        ...[0, 1].map(value => ({value, label: humanizeCarType(value)}))
    ]

    const handleChange = (e) => {
        const value = Number(e.target.value);
        onChange && onChange(isNaN(value) ? null : value);
    }

    return (
        <TextField
            placeholder="Выберите"
            {...other as any}
            select
            SelectProps={{
                native: true,
            }}
            onChange={handleChange}
        >
            {options.map(option => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </TextField>
    )
}